const VERSION = "00";
const TRACE_ID_LEN = 32;
const SPAN_ID_LEN = 16;
const FLAGS = "01";

function randomHex(len: number): string {
  const bytes = new Uint8Array(Math.ceil(len / 2));
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("").slice(0, len);
}

export class RumTracingService {
  generateTraceparent(): string {
    const traceId = randomHex(TRACE_ID_LEN);
    const spanId = randomHex(SPAN_ID_LEN);
    return `${VERSION}-${traceId}-${spanId}-${FLAGS}`;
  }

  buildTracestate(entries: Record<string, string | undefined>): string {
    return Object.entries(entries)
      .filter(([, v]) => typeof v === "string" && v.trim().length > 0)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
      .join(",");
  }
}

export const rumTracing = new RumTracingService();

